import angular from 'angular';
import ingredientFormComponent from './system-ingredient-form.component';

export default angular.module('components.admin.system-ingredients.system-ingredient-form', [])
  .component('systemIngredientForm', ingredientFormComponent)
  .name;



// WEBPACK FOOTER //
// ./components/app/admin/system-ingredients/system-ingredient-form/system-ingredient-form.module.js